import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

const LogicButton = kea.LogicButton;
type Style = "normal" | "pressed" | "dark";
export interface BotonDGViewProps {
    onClick?: () => void;
    text: string;
    style: Style;
    height: string;
    width: string;
    disableMargin?: boolean;
    icon?: string;
    iconStyle?: "center" | "left",
    fontSize?: string;
}

const colores: {
    [K in Style]: {
        color: string,
        background: string
    }
} = {
        normal: {
            color: "rgba(91,91,91,1)",
            background: "rgba(227,227,227, 1)",
        },
        pressed: {
            color: "white",
            background: "rgba(245, 102, 0, 1)",
        },
        dark: {
            color: "white",
            background: "rgba(90, 90, 90, 1)"
        }
    }

export class BotonDGView extends React.PureComponent<BotonDGViewProps>  {
    render() {
        const background = colores[this.props.style].background;
        const foreColor = colores[this.props.style].color;
        return (
            <div
                onClick={() => {
                    if (this.props.onClick) {
                        this.props.onClick();
                    }
                }}
                style={{
                    display: "flex",
                    background: background,
                    fontSize: this.props.fontSize || "12px",
                    color: foreColor,
                    flexDirection: "column",
                    height: this.props.height,
                    width: this.props.width,
                    cursor: "pointer",
                    marginLeft: this.props.disableMargin ? 0 : "2px",
                    marginRight: this.props.disableMargin ? 0 : "2px",
                    fontWeight: "bold",
                    fontFamily: "'Montserrat', sans-serif"
                }}
            >
                <div style={{ flex: "1 0 auto" }} />

                <div style={{ display: "flex", flexDirection: "row", flex: "0 1 auto" }} >

                    {
                        /*Icono izquierda*/
                        this.props.iconStyle == "left" &&
                        <div style={{ flex: "0 1 auto", marginRight: "20px" }} >
                            <img src={this.props.icon} />
                        </div>
                    }

                    {
                        this.props.iconStyle != "left" &&
                        <div style={{ flex: "1 0 auto" }} />
                    }

                    {
                        /*Icono central*/
                        this.props.iconStyle == "center" &&
                        <div style={{ flex: "0 1 auto", marginRight: "5px" }} >
                            <img src={this.props.icon} />
                        </div>
                    }

                    <div style={{ display: "flex", flexDirection: "column", flex: "0 1 auto" }}>
                        <div style={{ flex: "1 0 auto" }} />
                        <div style={{ flex: "0 1 auto" }} >
                            {this.props.text}
                        </div>
                        <div style={{ flex: "1 0 auto" }} />
                    </div>

                    <div style={{ flex: "1 0 auto" }} />
                </div>
                <div style={{ flex: "1 0 auto" }} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/diseño/items/boton.tsx